import React from "react";

import Icon1 from "./icons/Icon1.svg";
import Icon2 from "./icons/Icon2.svg";
import Icon3 from "./icons/Icon3.svg";

import "./style.scss";

/**
 * DialysisDragDropQuestion - Legend
 *  - A Legend for DragDropDialysis scale in dialysis prediction component.
 */
export function Legend() {
  return (
    <div className="dialysisdragdropquestion_legend">
      <div className="dialysisdragdropquestion_legend_subgroup">
        <img src={Icon1} alt="" />
        <p>Most increase in mass and volume</p>
      </div>
      <div className="dialysisdragdropquestion_legend_subgroup">
        <img src={Icon2} alt="" />
        <p> No change in mass and volume</p>
      </div>
      <div className="dialysisdragdropquestion_legend_subgroup">
        <img src={Icon3} alt="" />
        <p>Most decrease in mass and volume</p>
      </div>
    </div>
  );
}
